export default __webpack_public_path__ + "static/media/HU.96fe7bec.svg";